module.exports = __webpack_public_path__ + "img/hys-7.14f1b8cc.webp";